import type { SaveData } from '@/core/SaveData';

/**
 * difficultyCta.ts — the M114 FIRST-WIN difficulty nudge, pure + tested.
 *
 * The owner's rule: the first time a player WINS an offline race (quick or
 * tour) while still on the shipped DEFAULT difficulty (medium), the results
 * panel asks once whether they want to step up to HARD or keep the setting.
 * Once ever — `save.difficultyCtaShown` latches whatever they choose, and
 * pre-M114 saves that already hold a win anywhere backfill the latch TRUE at
 * the load boundary (SaveData.parseSave), so veterans never see it. Online
 * races never trigger it (the server pins online AI to legendary anyway),
 * and the tour FINALE is exempt at the call site (the championship summary
 * never carries the module — race results only).
 */

/** Should THIS finished race trigger the one-time step-up offer? */
export function shouldOfferDifficultyStep(
  save: Pick<SaveData, 'settings' | 'difficultyCtaShown'>,
  race: { online: boolean; place: number },
): boolean {
  return (
    !race.online &&
    race.place === 1 &&
    save.settings.difficulty === 'medium' &&
    !save.difficultyCtaShown
  );
}
